(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-grid')) {
    class FaqGrid extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.nav = this.querySelector('.faq-grid__pagination');
        this.pagesEl = this.querySelector('[data-faq-pages]');
        this.prevBtn = this.querySelector('[data-faq-prev]');
        this.nextBtn = this.querySelector('[data-faq-next]');
        this.rows = parseInt(this.dataset.rows, 10) || 4;
        this.page = 0;
        this.mq = window.matchMedia('(min-width: 750px)');

        this.onResize = () => {
          const first = this.items[this.page * this.perPage] || this.items[0];
          this.update();
          if (first) this.showItem(first, false);
        };
        this.mq.addEventListener('change', this.onResize);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.page - 1, true));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.page + 1, true));

        this.onBlockSelect = (event) => {
          const item = this.items.find((el) => el.contains(event.target) || el === event.target);
          if (item) this.showItem(item, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.update();
      }

      disconnectedCallback() {
        if (this.mq) this.mq.removeEventListener('change', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get perPage() {
        return this.rows * (this.mq.matches ? 2 : 1);
      }

      get pageCount() {
        return Math.max(1, Math.ceil(this.items.length / this.perPage));
      }

      showItem(item, scroll) {
        const index = this.items.indexOf(item);
        if (index < 0) return;
        this.go(Math.floor(index / this.perPage), scroll);
      }

      go(page, scroll) {
        this.page = Math.min(Math.max(page, 0), this.pageCount - 1);
        this.render();
        if (scroll) {
          const top = this.getBoundingClientRect().top;
          if (top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      update() {
        this.page = Math.min(this.page, this.pageCount - 1);
        this.render();
      }

      render() {
        const start = this.page * this.perPage;
        const end = start + this.perPage;
        this.items.forEach((item, i) => {
          item.hidden = i < start || i >= end;
        });

        if (!this.nav) return;
        const count = this.pageCount;
        this.nav.hidden = count <= 1;
        if (count <= 1) return;

        this.pagesEl.innerHTML = '';
        for (let i = 0; i < count; i++) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'faq-grid__page-btn';
          btn.textContent = String(i + 1);
          btn.setAttribute('aria-label', 'Seite ' + (i + 1));
          if (i === this.page) btn.setAttribute('aria-current', 'page');
          btn.addEventListener('click', () => this.go(i, true));
          this.pagesEl.appendChild(btn);
        }
        this.prevBtn.disabled = this.page === 0;
        this.nextBtn.disabled = this.page === count - 1;
      }
    }
    customElements.define('faq-grid', FaqGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
